export default __webpack_public_path__ + "static/media/bannermobile.10199a36.png";